module.exports = __webpack_public_path__ + "Roboto-Thin.44b78f142603eb69f593";


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/materialize-css/dist/fonts/roboto/Roboto-Thin.woff
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Thin.woff
// module chunks = styles